import { withStyles } from '../../tools/withStyles';
import { withAnimation } from '../../tools/withAnimation';
import { withSounds } from '../../tools/withSounds';
import { Component } from './Legal';
import { styles } from './Legal.styles';

const Legal = withAnimation({ flow: false })(withStyles(styles)(withSounds()(Component)));

export { Legal };

// Commit trace: 2025-10-13T17:24:00 - fix: adjust logic in index.js

// Commit trace: 2026-02-12T16:16:51 - feat: add utility helper to index.js
